import { render, staticRenderFns } from "./OrigenDeudaShow.vue?vue&type=template&id=18285dff"
import script from "./OrigenDeudaShow.vue?vue&type=script&lang=js"
export * from "./OrigenDeudaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports